export const numberFormat = number => {
    if (!number && number !== 0) return ''
    const [integer, decimal] = Number(number).toFixed(2).split('.')
    const formatted = integer.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    return decimal && decimal !== '00' ? `${formatted}.${decimal}` : formatted
}